import { Term } from "../pages/Dictionary/Dictionary";
import { API_BASE_URL } from '../config';

export const fetchTerms = async (): Promise<Term[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/misc/terms`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching terms:', error);
    throw error;
  }
};
